/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-01-22 21:35:02
 */

import {Component, Watch, Prop} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import SynthesizeReportApi, {SynthesizeReportDOI} from "./api/synthesizeReportApi";
import SynthesizeReportService from "./service/synthesizeReportService";
import { createNamespace, createBEM } from 'src/util/bem';
import QueryForm from 'src/components/queryForm/queryForm';
import Tab from 'src/components/tab/tab';
import FileUtil from 'src/util/fileUtil';
import Button from 'src/types/iview/Button';
let bem = createBEM('synthesize-report');

@Component
export default class SynthesizeReportComponent extends BasicSearchPage<SynthesizeReportService, SynthesizeReportDOI.RowDataI, SynthesizeReportDOI.QueryRowDataParamsI> {

	@Prop({
		type: Array
	})
	ids!: number[]

    className = createNamespace('pa0');
    pageShow = false
    currentDataType: string = '日报'
    dataType: {name: string, value: string}[] = [{name: '日报', value: '日报'},{name: '周报', value: '周报'},{name: '月报', value: '月报'},{name: '年报', value: '年报'}]

    tabChange(v) {
        this.$emit('change', v)
        this.columnDefs = this.service.createColumns()
        this.queryFormData = this.service.creatQueryForm()
        this.search()
    }
    @Watch('ids')
    stationChange() {
        this.search()
    }
    async export() {
        let {code, data} = await SynthesizeReportApi.export(this.currentDataType)
        if(code ===0) {
            FileUtil.download(data.download_url)
        }
    }
    renderQuery(h) {
		return <div class={bem('query')}>
            <Tab dataSource={this.dataType} v-model={this.currentDataType} on-change={this.tabChange.bind(this)}></Tab>
            <div class={bem('query-form')}>
                <QueryForm ref="queryForm" dataSource={this.queryFormData} on-search={this.search} showClear={false}/>
            </div>
            <Button class={createNamespace('mb5')} type="info" on-click={this.export.bind(this)}>导出</Button>
        </div>
    }


	@override
	loadService () {
		this.service = new SynthesizeReportService(this)
	}
}